import styled from 'styled-components';

export const Wrapper = styled.div`
  position: relative;
  height: calc(100% - 20px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  margin: 3px;
`;
